module.exports = __webpack_public_path__ + "img/logo_sider-sd.9422b6fb.png";